/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_increase_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find out how much a value has grown in percentage terms. Enter the original value and the new value to get the percentage increase.`)
};

const es_pct_increase_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descubre cuánto ha crecido un valor en términos porcentuales. Introduce el valor original y el valor nuevo para obtener el aumento porcentual.`)
};

const de_pct_increase_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finde heraus, wie stark ein Wert prozentual gewachsen ist. Gib den Ausgangswert und den neuen Wert ein, um den prozentualen Anstieg zu erhalten.`)
};

const nl_pct_increase_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ontdek hoeveel een waarde is gegroeid, uitgedrukt in procenten. Vul de oorspronkelijke waarde en de nieuwe waarde in om de percentagestijging te krijgen.`)
};

const fr_pct_increase_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Découvrez de combien une valeur a augmenté en pourcentage. Entrez la valeur d'origine et la nouvelle valeur pour obtenir l'augmentation en pourcentage.`)
};

const it_pct_increase_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scopri di quanto è cresciuto un valore in termini percentuali. Inserisci il valore originale e il nuovo valore per ottenere l'aumento percentuale.`)
};

const pt_br2_pct_increase_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descubra o quanto um valor cresceu em termos percentuais. Insira o valor original e o novo valor para obter o aumento percentual.`)
};

const pt_pct_increase_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descubra quanto um valor cresceu em termos percentuais. Insira o valor original e o novo valor para obter o aumento percentual.`)
};

const ja_pct_increase_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`値がパーセントでどれだけ増加したかを求めます。元の値と新しい値を入力するとパーセント増加が分かります。`)
};

const zh_pct_increase_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`了解一个数值以百分比形式增长了多少。输入原始值和新值即可得到百分比增长。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_increase_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_increase_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_increase_intro", locale)
	if (locale === "en") return en_pct_increase_intro(inputs)
	if (locale === "es") return es_pct_increase_intro(inputs)
	if (locale === "de") return de_pct_increase_intro(inputs)
	if (locale === "nl") return nl_pct_increase_intro(inputs)
	if (locale === "fr") return fr_pct_increase_intro(inputs)
	if (locale === "it") return it_pct_increase_intro(inputs)
	if (locale === "pt-BR") return pt_br2_pct_increase_intro(inputs)
	if (locale === "pt") return pt_pct_increase_intro(inputs)
	if (locale === "ja") return ja_pct_increase_intro(inputs)
	return zh_pct_increase_intro(inputs)
};